import * as Sentry from '@sentry/react';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import updatesNotification from './updateNotifications/updateNotificationsSlice';
import auth from '../reducers/auth';
import cast from '../reducers/cast';
import course from '../reducers/course';
import error from '../reducers/error';
import highlights from '../reducers/highlights';
import lesson from '../reducers/lesson';
import loading from '../reducers/loading';
import modal from '../reducers/modal';
import template from '../reducers/template';
import customization from '../reducers/customization';
import user from '../reducers/user';
import shelves from '../reducers/shelves';
import invite from '../reducers/invite';
import forum from '../reducers/forum';
import toastNotification from '../reducers/toastNotification';
import redirect from '../reducers/redirect';
import notifications from '../reducers/notifications';
import customizations from './customizations/slice';
import newLesson from './lesson/slice';
import showcase from './showcase/slice';
import toast from './toast/slice';
import newModules from './modules/slice';
import globalSearch from './globalSearch/slice';
import preLoadCheckout from '../reducers/preLoadCheckout';
import messages from '../reducers/messages';
import showcaseInvite from './showcaseInvite/slice';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  configureScopeWithState: (scope, state) => {
    if (!state?.user?.id) return null;
    return {
      ...state.user,
      id: state.user.id.toString(),
    };
  },
});

export const store = configureStore({
  reducer: {
    messages,
    preLoadCheckout,
    customization,
    globalSearch,
    newModules,
    course,
    cast,
    auth,
    user,
    lesson,
    highlights,
    loading,
    template,
    modal,
    error,
    shelves,
    showcase,
    showcaseInvite,
    forum,
    toastNotification,
    redirect,
    invite,
    notifications,
    updatesNotification,
    customizations,
    newLesson,
    toast,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  enhancers: [sentryReduxEnhancer],
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export const getStore = () => store;
